"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _default = function _default(theme) {
  return {
    root: {
      position: 'relative'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 40,
      boxSizing: 'border-box',
      borderBottom: "1px solid ".concat(theme.colors.placeholders)
    },
    isExpandable: {
      cursor: 'pointer'
    },
    Text: (0, _extends2.default)({
      fontWeight: 'normal',
      lineHeight: theme.typography.lineHeightBase
    }, theme.typography.defaultText, {
      color: theme.colors.black,
      textTransform: 'uppercase'
    }),
    icon: {
      lineHeight: '0',
      transition: 'transform 0.3s ease-out',
      willChange: 'transform',
      transform: 'rotate(-180deg) translateY(1px)',
      cursor: 'pointer',
      '&$collapsed': {
        transform: 'rotate(0) translateY(1px)'
      }
    },
    collapsed: {}
  };
};

exports.default = _default;